import React from "react";
import { ROLES } from "../../mock";
import Reveal from "./Reveal";

const Roles = () => (
  <section id="roles" className="relative overflow-hidden bg-card py-24 sm:py-28">
    <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary/5 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wider text-primary">Role-ready agents</span>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Useful across teams that live in spreadsheets
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Typical tasks by role. Save your own instructions as Skills.
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {ROLES.map((r, i) => (
          <Reveal key={r.name} delay={(i % 4) * 70}>
            <div className="group flex h-full items-start gap-4 rounded-2xl border border-border bg-background p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary/30 hover:shadow-lg">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent text-accent-foreground transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                <r.icon className="h-5 w-5" strokeWidth={2} />
              </span>
              <div>
                <h3 className="font-display font-semibold text-foreground">{r.name}</h3>
                <p className="mt-1 text-sm text-muted-foreground">{r.tasks}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Roles;
